import React from 'react';
import SEO from './SEO';

const PracheenaQAPage = ({ language, user }) => {
    const isAdmin = user && user.role === 'admin';
    const iframeSrc = `/pracheena-qa.html${isAdmin ? '?admin=true' : ''}`;

    return (
        <div className="min-h-screen bg-orange-50/30 flex flex-col">
            <SEO
                title="Pracheena QA - Ancient Valideekam Search"
                description="Search through translated ancient texts and Grantha scriptures using advanced phonetic matching."
                type="website"
            />

            {/* 
        This securely frames the standalone static HTML app so it blends 
        perfectly into the modern React UI while preserving its native Fuse.js speed!
      */}
            <iframe
                src={iframeSrc}
                title="Pracheena QA Interface"
                className="w-full flex-grow border-0"
                style={{ minHeight: 'calc(100vh - 4rem)' }}
            />
        </div>
    );
};

export default PracheenaQAPage;
